import React, { useEffect, useState } from "react";
import useRouter from "hooks/useRouter";
import useSearch from "redux/hooks/useSearch";
import { ArticleCard } from "@leafly-com/frontend-components";
import { Action, Category, trackEvent } from "utils/trackEvent";

const ArticleResults: React.FC = () => {
  const FALLBACK_IMAGE =
    "https://public.leafly.com/web-home/article-placeholder.jpg";
  const ITEMS_PER_LOAD = 6;

  const {
    parsedQuery: { q, searchCategory },
  } = useRouter();
  const { article: articles, loadMoreSearchResults } = useSearch();

  const viewingCountOnLoad = searchCategory === "article" ? 12 : 3;
  const [viewingCount, setViewingCount] = useState(viewingCountOnLoad);

  useEffect(() => {
    setViewingCount(viewingCountOnLoad);
  }, [searchCategory]);

  const handleLoadMore = async () => {
    document.activeElement instanceof HTMLElement &&
      document.activeElement.blur();
    const newViewingCount = ITEMS_PER_LOAD + viewingCount;
    loadMoreSearchResults("article", newViewingCount);
    trackEvent(
      Category.searchResults,
      Action.searchResultClicked,
      "show more news results button"
    );
    setViewingCount(newViewingCount);
  };

  if (!articles || !articles.length) return null;

  const mappedArticles = articles
    .slice(0, viewingCount)
    .map(
      ({
        id,
        author,
        image,
        relativeLink,
        tags,
        title,
        ...otherProperties
      }) => {
        const date = new Date(otherProperties.date).toLocaleDateString(
          "en-US",
          {
            timeZone: "America/Los_Angeles",
            year: "numeric",
            month: "long",
            day: "numeric",
          }
        );

        return {
          id,
          author,
          image,
          href: relativeLink,
          tags,
          title,
          date,
          imageUrl: image || FALLBACK_IMAGE,
        };
      }
    );

  return (
    <>
      <h3 className="heading--l">News & culture</h3>
      <div className="font-normal mb-lg">matching "{q}"</div>
      <div className="row">
        {mappedArticles.map((article) => (
          <div className="col md:col-1/2 lg:col-1/3 mb-md" key={article.id}>
            <ArticleCard
              {...article}
              className="block h-full elevation-low rounded overflow-hidden"
              onClick={() =>
                trackEvent(
                  Category.searchResults,
                  Action.searchResultClicked,
                  `article card - ${article.title}`
                )
              }
            />
          </div>
        ))}
      </div>
      {articles.length >= viewingCount && (
        <button
          className="button mt-lg lg:mt-xl"
          onClick={handleLoadMore}
          data-testid="article-results-load-more"
        >
          show more news results
        </button>
      )}
    </>
  );
};

export default ArticleResults;
